export enum PublicationStatus {
    Draft = 'draft',
    Live = 'live',
}
